




import Class from './variable-pie';
export default Class;
